import { JobPosting, WithContext } from 'schema-dts';
import { JobVacancy } from '../../Model/JobVacancy';
import { StaticSettings } from '../../StaticSettings';

function getHiringOrganizationName(job: JobVacancy) {
    if (!job.department) {
        return StaticSettings.client.name;
    }

    const hiringOrganizationName = job.department.title;
    if (hiringOrganizationName !== 'Default') {
        return hiringOrganizationName;
    } else {
        return StaticSettings.client.name;
    }
}

export function getStructuredData(job: JobVacancy): WithContext<JobPosting> {
    const hiringOrganizationName = getHiringOrganizationName(job);
    const core: WithContext<JobPosting> = {
        '@context': 'https://schema.org',
        '@type': 'JobPosting',
        name: job.title,
        title: job.title,
        datePosted: job.creationDate?.toLocaleDateString(),
        identifier: job.referenceId,
        hiringOrganization: {
            '@type': 'Organization',
            'name': hiringOrganizationName
        },
        description: job.description,
        skills: job.requirements,
        industry: job.industry?.name,
        educationRequirements: job.requiredLanguages
    };

    if (job.location) {
        core.jobLocation = {
            '@type': 'Place',
            'address': {
                '@type': 'PostalAddress',
                'addressCountry': job.location,
            }
        };
    }

    return core;
}
